// Copyright (c) 2020 Comsearch, Inc., All rights reserved

export const PRICING_MANAGEMENT_SEARCH_FORM = 'pricing-management-search-form'
export const PRICING_MANAGEMENT_UPDATE_DEFAULT_FORM = 'pricing-management-update-default-form'
export const PRICING_MANAGEMENT_UPDATE_SELECTED_FORM = 'pricing-management-update-selected-form'

export const searchFormSelectOptions = [{
  label: 'RENEWAL PRICING ADMIN - Email',
  value: 'email',
}, {
  label: 'RENEWAL PRICING ADMIN - Domain',
  value: 'domain',
}]

export const initialPricingManagementSearchValues = {
  pricingGroupType: 'email', // first value in the select element's options
  pricingGroupDefSearch: '',
}
